export const addIdPrefix = (id: string, prefix: string) => {
  if (!id) return;
  if (id.startsWith(`${prefix}_`)) return id;
  return `${prefix}_${id}`;
};
